import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorPage } from "./Pages/error";
import Header from "./Layouts/header/Header";
import { ToastContainer } from "react-toastify";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <ToastContainer newestOnTop={true} autoClose={15000} />
    <ErrorBoundary FallbackComponent={ErrorPage}>
      <Header />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
      <App />
      </LocalizationProvider>
    </ErrorBoundary>
  </>
);
// window.onerror = function (message, source, lineno, colno, error) {
//   console.error("Caught by window.onerror:", message, source, lineno, colno, error);
//   return window.location.href = '/error';
// };

reportWebVitals();
